import React from 'react';
import { Typography } from '../../typography/typography';
import styles from './expanded-section.module.scss';

type Props = {
  articleNumber: string;
  series: React.ReactNode;
  hexColor: string | undefined;
};

export const ExpandedSection: React.FC<Props> = ({ articleNumber, series, hexColor }) => {
  return (
    <div className={styles.root}>
      <div
        className={styles.colorSwatch}
        style={{
          '--igp-expanded-section-color': hexColor ?? '#fff',
        }}
      />
      <div className={styles.textContainer}>
        <Typography fontStyle="bold" variant="smalltext">
          {articleNumber}
        </Typography>
        <Typography fontStyle="bold" variant="smalltext">
          {series}
        </Typography>
      </div>
    </div>
  );
};
